import React from 'react';
import styled from 'styled-components';
import ChipTagStatus from '../ChipTagStatus/ChipTagStatus'
import { withStyles } from '@material-ui/core';

const FilterContainer = styled.div`
    font-weight: 500;
    position: relative;
    display: flex;
    align-items: center;
    text-align: center;
    height: 40px;
`
const TabWrapper = styled.div`
    margin-right: 20px;
    color: #545454;
    font-size: 1.143em;
`

const Tab = styled.span`
    font-size: 12px;
`

const styles = theme => ({
    filter: {
        marginTop: '-8px',
        marginBottom: '4px',
        fontSize: '16px',
        marginRight: '0px',
        '& span': {
            cursor: 'pointer',
            color: '##989898',
            marginRight: '0px',
        },
        '& span .number': {
            cursor: 'pointer',
            marginLeft: '2px',
            color: '#989898',
            fontSize: '10px'
        },
        '& span:hover': {
            color: '#0A54A2',
        },
        '& span:hover .number': {
            color: '#0A54A2',
        },
        '& span.active': {
            borderBottom: '2px solid #0A54A2',
            color: '#0A54A2',
        },
        '& span.active .number': {
            color: '#0A54A2',
            border: '0'
        },
        '& span.disable': {
            color: '#DCDCDC',
            cursor: 'default'
        },
        '& span.disable .number': {
            color: '#DCDCDC',
            cursor: 'default'
        }
    }
})

const FilterTabs = (props) => {
    const { classes, tabs, tabSelected = 'All', target, onClick = () => { } } = props;

    let filterTabs = [];
    if (tabs === undefined || tabs.length === 0) {
        return ''
    }

    for (const [index, tab] of tabs.entries()) {
        filterTabs.push(
            <TabWrapper key={index}>
                {tab.color ? <ChipTagStatus className={tab.colorClass} color={tab.color} /> : null}
                <Tab key={index} className={tab.value === tabSelected ? 'active' : tab.disable === true ? 'disable' : ''} onClick={tab.disable !== true ? () => { onClick(target, tab.value) } : () => { }}>{tab.label}<span className={"number"}>({tab.count})</span></Tab>
            </TabWrapper>)
    }

    return (
        <FilterContainer className={classes.filter}>
            {filterTabs}
        </FilterContainer>
    )
}

export default withStyles(styles)(FilterTabs);